document.addEventListener('DOMContentLoaded', function () {
  initSwatchHover(document);
});

// Re-init on device type change
const touchQuery = window.matchMedia('(hover: none) and (pointer: coarse)');
touchQuery.addEventListener('change', function () {
  document.querySelectorAll('.card-wrapper[data-swatch-init]').forEach(card => {
    card.removeAttribute('data-swatch-init');
  });
  initSwatchHover(document);
});

// Main init function
function initSwatchHover(context) {
  context.querySelectorAll('.card-wrapper:not([data-swatch-init])').forEach(card => {
    card.setAttribute('data-swatch-init', 'true');

    const primaryImg = card.querySelector('.card__media .media img');
    if (!primaryImg) return;

    const dataEl = card.querySelector('.card-variant-data');
    if (!dataEl) return;

    let variantData;
    try {
      variantData = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.warn('Variant JSON parse error', e);
      return;
    }

    const originalSrc = primaryImg.src;
    const originalSrcset = primaryImg.srcset;

    // Build variant map
    const variantMap = {};
    Object.values(variantData).forEach(v => {
      if (v.image && v.options) {
        const base = v.image.split('?')[0];
        const img = new Image();
        img.src = `${base}?width=533`; // preload
        v.options.forEach(opt => {
          variantMap[opt.toLowerCase()] = base;
        });
      }
    });

    // Bind swatch interactions
    card.querySelectorAll('.swatch-input__input').forEach(input => {
      const label = input.nextElementSibling;
      if (!label) return;

      function applyImage() {
        const swatchValue = input.value?.toLowerCase();
        const base = variantMap[swatchValue];
        if (!base) return;

        primaryImg.srcset = [165, 360, 533, 720, 940, 1066]
          .map(w => `${base}?width=${w} ${w}w`)
          .join(', ');
        primaryImg.src = `${base}?width=533`;
      }

      function resetImage() {
        primaryImg.src = originalSrc;
        primaryImg.srcset = originalSrcset;
      }

      // Always bind label click for mobile & touch devices
      label.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        input.checked = true;
        applyImage();
      });

      // Desktop hover
      label.addEventListener('pointerenter', applyImage);
      label.addEventListener('pointerleave', resetImage);
    });
  });
}

// Expose globally
window.initSwatchHover = initSwatchHover;



// document.addEventListener('DOMContentLoaded', function () {
//   initSwatchHover(document);
// });

// // Listen for device type switch (desktop <-> mobile) and re-init
// const touchQuery = window.matchMedia('(hover: none) and (pointer: coarse)');
// touchQuery.addEventListener('change', function () {
//   document.querySelectorAll('.card-wrapper[data-swatch-init]').forEach(card => {
//     card.removeAttribute('data-swatch-init');
//   });
//   window.initSwatchHover(document);
// });

// // Expose for infinite scroll, filter, and recommendations re-init
// window.initSwatchHover = function (context) {
//   const isTouchDevice = () => window.matchMedia('(hover: none) and (pointer: coarse)').matches;

//   context.querySelectorAll('.card-wrapper:not([data-swatch-init])').forEach(card => {
//     card.setAttribute('data-swatch-init', 'true');

//     const primaryImg = card.querySelector('.card__media .media img');
//     if (!primaryImg) return;

//     const dataEl = card.querySelector('.card-variant-data');
//     if (!dataEl) return;

//     let variantData;
//     try {
//       variantData = JSON.parse(dataEl.textContent);
//     } catch (e) {
//       console.warn('Variant JSON parse error', e);
//       return;
//     }

//     const originalSrc = primaryImg.src;
//     const originalSrcset = primaryImg.srcset;

//     // -------------------------------
//     // Create fast lookup map
//     // -------------------------------
//     const variantMap = {};

//     Object.values(variantData).forEach(v => {
//       if (v.image && v.options) {
//         const base = v.image.split('?')[0];

//         // Preload image (important for speed)
//         const img = new Image();
//         img.src = `${base}?width=533`;

//         // Map option value -> image
//         v.options.forEach(opt => {
//           variantMap[opt.toLowerCase()] = base;
//         });
//       }
//     });

//     // -------------------------------
//     // Hover / Click events
//     // -------------------------------
//     card.querySelectorAll('.swatch-input__input').forEach(input => {
//       const label = input.nextElementSibling;
//       if (!label) return;

//       function applyImage() {
//         const swatchValue = input.value?.toLowerCase();
//         const base = variantMap[swatchValue];
//         if (!base) return;

//         primaryImg.srcset = [165, 360, 533, 720, 940, 1066]
//           .map(w => `${base}?width=${w} ${w}w`)
//           .join(', ');
//         primaryImg.src = `${base}?width=533`;
//       }

//       function resetImage() {
//         primaryImg.src = originalSrc;
//         primaryImg.srcset = originalSrcset;
//       }

//       if (isTouchDevice()) {
//         // Mobile: click to change image, prevent redirect to PDP
//         label.addEventListener('click', function (e) {
//           e.preventDefault();
//           e.stopPropagation();
//           applyImage();
//         });
//       } else {
//         // Desktop: hover to change image
//         label.addEventListener('pointerenter', applyImage);
//         label.addEventListener('pointerleave', resetImage);
//       }
//     });
//   });
// };